import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQ_ITEMS } from "@/data/content";
import { Reveal } from "@/components/Reveal";

const Faq = () => (
  <section data-testid="faq-section" className="py-16 sm:py-24 bg-[#f9f8f5] border-t border-[#e5e1d8]">
    <div className="container-avelis">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-4">
          <Reveal>
            <p className="eyebrow"><span className="dot-sage" />Questions fréquentes</p>
            <h2 className="h2-avelis mt-4">Vous avez encore une question ?</h2>
          </Reveal>
        </div>
        <div className="lg:col-span-8">
          <Reveal delay={0.1}>
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {FAQ_ITEMS.map((item, i) => (
                <AccordionItem
                  key={i}
                  value={`faq-${i}`}
                  className="border-b border-[#e5e1d8] px-1"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger
                    data-testid={`faq-question-${i}`}
                    className="text-left text-base sm:text-lg font-bold tracking-tight text-[#0d2731] py-6 hover:text-[#176b70] hover:no-underline transition-colors"
                  >
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent
                    data-testid={`faq-answer-${i}`}
                    className="text-base text-[#4b585e] leading-relaxed pb-7 pr-6"
                  >
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default Faq;
